import styled from "styled-components"

const StyledParagraph = styled.p`
  font-size: 18px;
  font-family: "Made Light", sans-serif;
  line-height: 29px;
  letter-spacing: 0.3px;
  color: #000;
  opacity: 0.6;
  @media (min-width: 1024px) {
    font-size: 20px;
    line-height: 32px;
  }
`

export default StyledParagraph
